import { NgModule } from '@angular/core';
import { BrowserModule } from '@angular/platform-browser';
import { SimpleIconsJcbComponent } from './simple-icons-jcb.component';
 @NgModule({
    imports:      [ BrowserModule ],
    providers:    [],
    declarations: [ SimpleIconsJcbComponent ],
    exports:      [ SimpleIconsJcbComponent ],
    bootstrap:    []
})
export class SimpleIconsJcbModule {}
